




















import { Component, Vue } from 'vue-property-decorator'
import restaurants, { RestaurantPublic } from '@/services/Restaurants'
import ThankYou from '@/components/guest/ThankYou.vue'
@Component({
  components: { ThankYou },
})
export default class ThankYouPage extends Vue {
  public restaurantId: string | null = null
  public accessCode: string | null = null
  public waiterName: string | null = null
  public restaurant: RestaurantPublic | null = null

  public async created() {
    this.restaurantId = this.$route.params.restaurantId
    this.accessCode = this.$route.params.accessCode
    this.waiterName = this.$route.query['waiter-name'] ? this.$route.query['waiter-name'] + '' : ''

    if (this.restaurantId) {
      this.restaurant = await restaurants.getPublicRestaurant(this.restaurantId)
    }
  }
}
